import React, {useEffect, useState} from 'react';

import Skeleton from 'coreComponents/Skeleton';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import {Contentful} from 'brand/app/contentful/components';
import Image from 'brandComponents/Image';

import {IOrderStatusWidgetProps} from './IOrderStatusWidget';

import styles from './OrderStatusWidget.module.scss';

const OrderStatusWidget = ({order}: IOrderStatusWidgetProps) => {
	const {managerRepository} = useGeneralProvider();
	const [loaded, setLoaded] = useState(false);
	const [orderStatusWidget, setOrderStatusWidget] = useState(null);
	const trackingImageURL = order.getTrackingImageURL();

	useEffect(() => {
		if (!trackingImageURL) {
			const cmsProvider = managerRepository.getContentMgr().getCMSProvider();
			cmsProvider
				.getContent('GetText', {
					variables: {
						id: 'order-tracking-content',
					},
				})
				.then((data) => {
					if (data?.textCollection?.items) {
						setOrderStatusWidget(data?.textCollection?.items[0]);
					}
				})
				.finally(() => {
					setLoaded(true);
				});
		}
	}, [trackingImageURL]);

	return (
		<div className={styles['order-status-widget']}>
			{trackingImageURL ? (
				<Image src={trackingImageURL} showSkeleton={false} alt="" />
			) : loaded ? (
				<Contentful initialData={orderStatusWidget} />
			) : (
				<Skeleton key="orderStatus" height="40px" />
			)}
		</div>
	);
};

export default OrderStatusWidget;
